/*
  Opens the cart drawer after the VINWEAR configurators add an item.

  The five configurator sections build a variant themselves and post to
  /cart/add.js directly, rather than submitting a product form, so none of
  Dawn's own add-to-cart plumbing runs for them. They previously finished by
  sending the shopper to /cart. With the drawer switched on that was the one
  path that still navigated away from the page, which defeats the point of a
  drawer on the main buying journey.

  This asks Shopify for the two sections the drawer re-renders and hands them
  to the drawer, which repaints and opens itself.

  If the drawer is not on the page - because cart_type is 'page' or
  'notification' - or the request fails, it falls back to /cart so the shopper
  always reaches their cart.
*/
window.vwCartAdded = function () {
  var drawer = document.querySelector('cart-drawer');
  var fallback = function () { window.location.href = '/cart'; };

  if (!drawer || typeof drawer.renderContents !== 'function') { fallback(); return; }

  fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble')
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (sections) { drawer.renderContents({ sections: sections }); })
    .catch(fallback);
};
